import React from 'react';
import styled from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { duotone } from '@fortawesome/fontawesome-svg-core/import.macro';

const LoadingContainer = styled.div`
	width: 100vw;
	height: 100vh;
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	font-size: 10rem;
`


const Loading = ({size, fullpage}) => {
	if (fullpage) {
		return (
			<LoadingContainer>
				<FontAwesomeIcon icon={duotone("spinner-third")} spin size={size} />
			</LoadingContainer>
		)
	}
	return (
		<FontAwesomeIcon icon={duotone("spinner-third")} spin />
	);
};

export default Loading;